import type { GuestCount } from '../../components/booking/meal-plan/types';

const getGuestCount = (guestCountRaw: string): GuestCount => {
  const countArray = guestCountRaw ? guestCountRaw.split('_') : [];

  return {
    adultCount: Number(countArray[0]) || 1,
    seniorElementarySchoolChildCount: Number(countArray[1]) || 0,
    juniorElementarySchoolChildCount: Number(countArray[2]) || 0,
    infantWithMealAndFutonCount: Number(countArray[3]) || 0,
    infantWithMealCount: Number(countArray[4]) || 0,
    infantWithFutonCount: Number(countArray[5]) || 0,
    infantWithoutMealAndFutonCount: Number(countArray[6]) || 0,
  };
};

export default getGuestCount;
